import React from "react";
import jQuery from 'jquery/dist/jquery'

export default class Paginate extends React.Component 
{
    constructor(props)
    {
        super(props);
    }

    componentDidMount()
    {    
        (function($) {           
            var pagify = {
                items: {},
                container: null,
                totalPages: 1,
                perPage: 3,
                currentPage: 0,
                range:3,
                anchor: null,
                prev: null,
                next: null,              
                createNavigation: function() 
                {                    
                    this.totalPages = Math.ceil(this.items.length / this.perPage);                                       
        
                    $('.pagination', this.container.parent()).remove();    

                    var prev = $('<a class="nav prev disabled" data-next="false">Prev <span>...</span></a>');   
                    var next = $('<a class="nav next" data-next="true"><span>...</span> Next</a>');

                    var pagination = $('<div class="pagination"></div>').append(prev);

                    for (var i = 0; i < this.totalPages; i++) 
                    {
                        var pageElClass = "page";
                    
                        if (!i)
                            pageElClass = "page current";

                        if(i+1 > this.range)
                            pageElClass = "page hide";

                        var pageEl = '<a class="' + pageElClass + '" data-page="' + (
                                     i + 1) + '">' + (
                                     i + 1) + "</a>";

                        pagination.append(pageEl);
                    }

                    if(this.totalPages > this.range)
                    {
                        next.addClass('dots');
                    }

                    pagination.append(next);                    

                    this.prev = prev;
                    this.next = next;

                    if(this.topnav)
                        this.container.before(pagination.clone().addClass('top'));

                    this.container.after(pagination);                    
        
                    var that = this;

                    $("body").off("click", ".nav");

                    this.navigator = $("body").on("click", ".nav", function() 
                    {
                        var el = $(this);
                        that.navigate(el.data("next"));
                    });
        
                    $("body").off("click", ".page");

                    this.pageNavigator = $("body").on("click", ".page", function() 
                    {
                        var el = $(this);
                        that.goToPage(el.data("page"));
                    });
                },
                navigate: function(next) 
                {                    
                    if (isNaN(next) || next === undefined) 
                    {
                        next = true;
                    }

                    $(".pagination .nav").removeClass("disabled");
                    
                    if (next) 
                    {
                        this.currentPage++;

                        if (this.currentPage > (this.totalPages - 1))
                            this.currentPage = (this.totalPages - 1);

                        if (this.currentPage == (this.totalPages - 1))
                            $(".pagination .nav.next").addClass("disabled");
                       
                        $(".pagination .nav.prev").removeClass("dots");

                        if(this.currentPage+1 >= this.range)
                        {
                            $(".pagination .nav.prev").addClass("dots");
                        }
                            
                    }
                    else 
                    {
                        this.currentPage--;

                        if (this.currentPage < 0)
                            this.currentPage = 0;

                        if (this.currentPage == 0)
                            $(".pagination .nav.prev").addClass("disabled");
                        
                        $(".pagination .nav.prev").removeClass("dots");

                        if(this.currentPage+1 >= this.range)
                        {
                            $(".pagination .nav.prev").addClass("dots");
                        }
                    }                
        
                    this.showItems();
                    
                    if(this.anchor)
                    {                        
                        window.location.replace(`#${this.anchor}`)
                        return;
                    } 
                },
                updateNavigation: function() 
                {        
                    var pages = $(".pagination .page");

                    var current = this.currentPage + 1;
                    var current_range_prev = this.currentPage;
                    var current_range_next = this.currentPage + 2;

                    pages.removeClass("current");  
                    pages.addClass("hide");   
                    
                    switch(current)
                    {
                        case 1:                        
                            $('.pagination .page[data-page="'+2+'"]').removeClass('hide');
                            $('.pagination .page[data-page="'+3+'"]').removeClass('hide'); 
                        break;

                        case 2:
                            $('.pagination .page[data-page="'+1+'"]').removeClass('hide');
                            $('.pagination .page[data-page="'+3+'"]').removeClass('hide');
                            break;

                        default:
                            if(current >= this.range)
                            {
                                $('.pagination .page[data-page="'+(current_range_prev)+'"]').removeClass('hide');        
                                $('.pagination .page[data-page="'+(current_range_next)+'"]').removeClass('hide');                        
                            }
                            break;

                    }                      
                    
                    $('.pagination .page[data-page="'+(current)+'"]').addClass("current").removeClass('hide');                    
                },
                goToPage: function(page) 
                {        
                    this.currentPage = page - 1;
        
                    $(".pagination .nav").removeClass("disabled");

                    if (this.currentPage == (this.totalPages - 1))
                        $(".pagination .nav.next").addClass("disabled");
        
                    if (this.currentPage == 0)
                        $(".pagination .nav.prev").addClass("disabled");

                    this.showItems();

                    if(this.anchor)
                    {                        
                        window.location.replace(`#${this.anchor}`)
                        return;
                    }                    
                    
                    window.scrollTo(0, 0); 
                },
                showItems: function() 
                {
                    this.items.hide();

                    var base = this.perPage * this.currentPage;

                    this.items.slice(base, base + this.perPage).show();
                    
                    this.updateNavigation();
                                       
                },
                urlToPage:function()
                {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);

                    if(urlParams.get('page') != null)
                    {
                        this.goToPage(urlParams.get('page'));
                    }
                },
                init: function(container, items, perPage, topNavigation, anchor) 
                {                    
                    this.container = container;
                    this.anchor = anchor || false;
                    this.currentPage = 0;
                    this.totalPages = 1;
                    this.perPage = perPage;
                    this.items = items;
                    this.topnav = topNavigation || false;
                    this.createNavigation();
                    this.urlToPage();
                    this.showItems();                    
                }
            };
        
            // stuff it all into a jQuery method!
            $.fn.pagify = function(perPage, itemSelector, topNav, anchor) 
            {                
                var el = $(this);
                var items = $(itemSelector, el);               

                // default perPage to 5
                if (isNaN(perPage) || perPage === undefined) 
                {
                    perPage = 3;
                }
        
                // don't fire if fewer items than perPage
                if (items.length <= perPage) 
                {
                    return true;
                }
        
                pagify.init(el, items, perPage, topNav, anchor);
            };
        })(jQuery);

        jQuery("."+this.props.class).pagify(this.props.perpage, ".single-item", this.props.topnav, this.props.anchor);
    }

    render()
    {
        return(
            <>                   
                {this.props.children}                           
            </> 
        )
    }
}